export const ATTRIBUTE_TYPE_VALUES = {
    Boolean: 'Boolean',
    Integer: 'Integer',
    Double: 'Double',
    String: 'String',
    Time: 'Time',
    Date: 'Date',
    DateTime: 'DateTime',
    File: 'File',
} as const;

export const ATTRIBUTE_TYPES: Record<number, string> = {
    1: ATTRIBUTE_TYPE_VALUES.Integer,
    2: ATTRIBUTE_TYPE_VALUES.Boolean,
    4: ATTRIBUTE_TYPE_VALUES.Double,
    5: ATTRIBUTE_TYPE_VALUES.String,
    6: ATTRIBUTE_TYPE_VALUES.Time,
    7: ATTRIBUTE_TYPE_VALUES.Date,
    8: ATTRIBUTE_TYPE_VALUES.DateTime,
    10: ATTRIBUTE_TYPE_VALUES.File,
};
